import { StepName } from "@layouts/stepper/step-name";
import { RootState } from "@redux/store";
import { memo } from "react";
import { useSelector } from "react-redux";

interface SummaryStepNameProps {
  stepNumber: number;
}

export const SummaryStepName = memo(({ stepNumber }: SummaryStepNameProps) => {
  const storedIsReview = useSelector(
    (state: RootState) => state.platformAnalysis.platformAnalysis?.isReview,
  );

  return (
    <StepName
      name={storedIsReview ? "Suitability Review summary" : "Summary"}
      stepNumber={stepNumber}
    />
  );
});
